import pickBy from 'lodash/pickBy'

export const removeUndefinedKeys = <T>(obj: {
  [key: string]: T | undefined
}): { [key: string]: T } =>
  pickBy(obj, (value): value is T => value !== undefined)
